/**
 * TODO: This component is not in use at the moment. We may not export the taxonomy translations.
 * Keeping it here for now, but remove it when we've decided what to do with it.
 */
import { useCallback } from 'react'
import { Button } from '@components/v2/button'
import { useExportTaxonomyTranslation } from '@global/hooks/mutations/taxonomy-translations'
import { TaxonomyTranslation } from '@taxonomy-translation/types'
import { getPercent } from '@taxonomy-translation/utils'
import { Modal } from './modal'
import { t } from '@lingui/core/macro'

interface Props {
  translation: TaxonomyTranslation
  onClose: () => void
}

const reviewProgress = (reviewProgressPercentage: number) =>
  t` You've only reviewed ${reviewProgressPercentage}%.`

export const ExportModal = ({ translation, onClose }: Props) => {
  const { mutate, isPending } = useExportTaxonomyTranslation(translation.uuid, {
    onSuccess: (data: Blob) => {
      const url = window.URL.createObjectURL(data)
      const link = document.createElement('a')
      link.href = url
      const fileName = `${translation.name}.xlsx`
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(url)
      link.remove()

      onClose()
    },
  })

  const exportTaxonomyTranslation = useCallback(() => {
    mutate()
  }, [mutate])

  const reviewProgressPercentage = getPercent(
    translation.reviewProgress?.reviewed,
    translation.matchesMetrics?.translations,
  )

  return (
    <Modal onClose={onClose}>
      <div>
        <h2 className="font-sans mb-7 font-bold text-xl">{t`Are you sure?`}</h2>
        <p className="text-sm mb-14">
          {t`Are you sure you want to export a translated .xlsx file?`}
          {reviewProgressPercentage < 40
            ? reviewProgress(Math.round(reviewProgressPercentage))
            : ''}
        </p>
        <div className="flex justify-between mt-4">
          <Button onClick={onClose} variant="outline" className="bg-[#F6F8FA]">
            {t`Close`}
          </Button>
          <Button onClick={exportTaxonomyTranslation} isLoading={isPending}>
            <span>{t`Export`}</span>
          </Button>
        </div>
      </div>
    </Modal>
  )
}
